import * as React from 'react';
import { ReactComponent as CertificateIconSVG } from '../../assets/icons/mevo/ic_certificate.svg';
import IconPattern, { IconProps } from './_IconPattern';

const CertificateIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={CertificateIconSVG} variantPlaces={[1, 2]} {...props} />;
};

export default CertificateIcon;
